import cs from "classnames";
import type { FunctionComponent, PropsWithChildren } from "react";

type HeaderContainerProps = { forModule: "popup" | "table" };

export const HeaderContainer: FunctionComponent<
  PropsWithChildren<HeaderContainerProps>
> = ({ forModule, children }) => {
  return (
    <div
      className={cs(
        "flex items-center justify-between",
        forModule === "table" && "px-2 mb-10",
      )}
    >
      {children}
    </div>
  );
};
